<template>
  <v-dialog width="800px" persistent :value="show" @input="$emit('change', $event)">
    <v-card height="563px">
      <v-card-text class="h-100">
        <v-layout column class="h-100">
          <v-flex>
            <v-layout class="h-100 mt-2">
              <v-flex md4>
                <v-layout class="h-100" column>
                  <v-flex md1 class="text-xs-center">
                    <span class="title pa-0">
                      Detalles
                    </span>
                  </v-flex>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Grupo: </span> 
                        <span class="body-2">
                          {{group.letter}}
                        </span>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Porcentaje de riesgo: </span> 
                        <span class="body-2">
                          {{group.percentage}}%
                        </span>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Cuentas: </span> 
                        <span class="body-2">
                          {{new Intl.NumberFormat('es-VE').format(group.quantity)}} ({{group.percentageOfGlobal}}%)
                        </span>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Monto total: </span> 
                        <span class="body-2">
                          ${{new Intl.NumberFormat('es-VE').format(group.dueBalance)}}
                        </span>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Contactabilidad SMS: </span> 
                        <v-flex xs12 style="position:relative;">
                        <v-progress-linear
                            color="green"
                            height="16"
                            style="border-radius: 0!important; margin: 1%;"
                            :value="group.sms" />
                          <span class="bar-text">{{group.sms}}%</span>
                        </v-flex>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Contactabilidad email:  </span>
                        <v-flex xs12 style="position:relative;">
                        <v-progress-linear
                            color="green"
                            height="16"
                            style="border-radius: 0!important; margin: 1%;"
                            :value="group.email" />
                          <span class="bar-text">{{group.email}}%</span>
                        </v-flex>
                      </v-flex>
                      <v-flex mt-3 xs12>
                        <span class="subheading"> Contactabilidad teléfono: </span> 
                        <v-flex xs12 style="position:relative;">
                        <v-progress-linear
                            color="green"
                            height="16"
                            style="border-radius: 0!important; margin: 1%;"
                            :value="group.phone" />
                          <span class="bar-text">{{group.phone}}%</span>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-divider
                class="vertical mx-3"
                inset></v-divider>
              </v-flex>
              <v-flex md8>
                <v-layout class="h-100" column>
                  <v-flex md1 class="text-xs-center">
                    <span class="title pa-0">
                      Caracteristicas
                    </span>
                  </v-flex>
                  <v-flex>
                    <vue-perfect-scrollbar class="contenido">
                      <v-layout row wrap pr-3>
                        <v-flex md12 mt-2
                          v-for="(value, key) in filtered(group.segment_detail)"
                          :key="`detail-feature-${key}`"
                          class="text-xs-center beautiful-list">
                          <span>
                            {{ names[key] }}
                          </span>
                          <template v-if="areNumbers(value, key)">
                            <v-list-tile class="b-borders" >
                              <span v-for="(name, j) in value" class="caption mr-2"
                                :key="`value-${j}-${key}-${group.name}`">
                                {{ showFeatureValueName(key, name) }}
                                <template v-if="j + 1 < value.length">
                                  ,
                                </template>
                              </span>
                            </v-list-tile>
                          </template>
                          <template v-else>
                            <v-list-tile v-for="(name, j) in value" 
                              class="b-borders" 
                              :key="`value-${j}-${key}-${group.name}`">
                              <span class="caption">
                                {{ showFeatureValueName(key, name) }}
                              </span>
                            </v-list-tile>
                          </template>
                        </v-flex>
                      </v-layout>
                    </vue-perfect-scrollbar>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <v-btn flat @click="$emit('change', false)">Cerrar</v-btn>
              <v-btn flat class="k-orange-linear-text" @click="download()">Descargar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    names() {
      const names = {
        gender_id: 'Genero',
        currency_id: 'Moneda',
        age_group_id: 'Grupo de edad',
        account_type_id: 'Producto',
        portfolio_type_id: 'Tipo de cartera',
        marital_status: 'Estado marital',
      };
      for (let i = 0; i < this.dimentions.length; i += 1) {
        names[this.dimentions[i].field] = this.dimentions[i].title;
      }
      return names;
    },
    user() {
      return this.$auth.user();
    },
    ...mapGetters({
      dimentions: 'dimentions',
      gender_id: 'gender',
      age_group_id: 'age_group',
      currency_id: 'currency',
      account_type_id: 'account_type',
      portfolio_type_id: 'portfolio_type',
    }),
  },
  methods: {
    filtered(features) {
      return _.pickBy(features, (x, key) => this.names[key]);
    },
    download() {
      this.$emit('download');
      this.$emit('change', false);
    },
    showFeatureValueName(key, value) {
      let name = '';
      if (key === 'marital_status') {
        if (value) {
          name = 'Casado';
        } else {
          name = 'Soltero';
        }
      } else if (key.includes('dim')) {
        const temp = this.dimentions.find(x => x.field === key);
        if (temp) {
          name = (temp.items.find(x => x.id === value) || {}).name || '';
        }
      } else {
        name = this[key](value).name;
      }
      return name;
    },
    areNumbers(values, key) {
      for (let i = 0; i < values.length; i += 1) {
        const test = parseInt(this.showFeatureValueName(key, values[i]), 10);
        if (!test) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style scoped>
.contenido {
  height: 455px;
}
.vertical {
  border: none;
  border-left: 1px solid hsl(200, 2%, 79%);
  height: 100%;
  border-radius: 20%;
  width: 1px;
}
.bar-text {
  position: absolute;
  bottom: 0;
  left: 7px;
  color: #fff;
  z-index: 12;
  text-shadow: 0px 2px 4px #000;
  font-size: 13px;
}
.beautiful-list {
  border: 1px solid #d6d3d3;
  border-width: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/segmentation/InfoModal.vue